<template>
  <component :is="currentComponent" />
</template>

<script>
export default {
  data() {
    return {
      currentComponent: null
    }
  },
  created() {
    // Check the query parameters with case-insensitive comparison
    const campaignName = this.$route.query.campaignName || this.$route.query.campaignname;
    if (campaignName && campaignName.toLowerCase() === 'sitefinityprt2005') {
      import('@/views/pages/RegisterPRT2005.vue').then(module => {
        this.currentComponent = module.default;
      });
    } else {
      import('@/views/pages/Register.vue').then(module => {
        this.currentComponent = module.default;
      });
    }
  }
}
</script> 
